// extracted by mini-css-extract-plugin
export var billingWrapper = "BillingPeriods-module--billingWrapper--8628b";
export var label = "BillingPeriods-module--label--d0604";
export var switchRoot = "BillingPeriods-module--switchRoot--16fa9";
export var switchRootCheckedBusiness = "BillingPeriods-module--switchRootCheckedBusiness--45236";
export var switchRootCheckedStarter = "BillingPeriods-module--switchRootCheckedStarter--c54fd";
export var switchRootCheckedTeam = "BillingPeriods-module--switchRootCheckedTeam--46360";
export var switchThumb = "BillingPeriods-module--switchThumb--e478b";